import IconArrowRightLarge from '@picsart/icons/IconArrowRightLarge';
import cls from 'classnames';
import { useCallback } from 'react';

import NewLabel from '../../core/NewLabel';
import Card from '../../layout/Card';
import { SingleToolAppIcon } from '../SingleToolAppIcon';

import ISingleToolCard from './types';
import useStyles from './styles';

const SingleToolCard = ({
  id,
  className,
  description,
  href,
  icon,
  longName,
  name,
  onClick,
  showDescription = false,
  hasNewLabel = false,
  iconSize = 'small',
  element = 'h3',
  cta,
}: ISingleToolCard) => {
  const classes = useStyles({ showDescription });
  const Tag = element;

  const handleClick = useCallback(() => {
    onClick && onClick(id);
  }, [id, onClick]);

  return (
    <a
      className={cls(classes.root, className)}
      onClick={handleClick}
      target="_blank"
      href={href}
      rel="noreferrer"
    >
      <Card className={classes.listItem}>
        <div className={classes.titleContainer}>
          <Tag className={classes.itemTitle}>
            <div>
              <SingleToolAppIcon icon={{ width: 20, height: 20, ...icon }} size={iconSize} />
            </div>
            <span className={classes.itemTitleText}>{longName || name}</span>
          </Tag>
          {hasNewLabel && <NewLabel size="medium" className={classes.newLabel} />}
        </div>
        {showDescription && (
          <>
            <p className={classes.itemDescription}>{description}</p>
            <div className={classes.spacer} />
          </>
        )}
        {cta ?? (
          <SingleToolAppIcon
            isRound
            size="small"
            icon={{
              src: IconArrowRightLarge,
              background: 'var(--x-bg-6)',
              fill: 'var(--x-textf-field-color-1)',
              width: 16,
              height: 16,
            }}
          />
        )}
      </Card>
    </a>
  );
};

export default SingleToolCard;
